export default "__VITE_ASSET__CYKx7CbW__"